// extracted by mini-css-extract-plugin
export default {"brdr":"tv_brdr__wkK6q","secondclor":"tv_secondclor__Fo2fp"};